import { api } from '../api';

export const sendMessage = (message) => {
  return api().post('/messages/', message);
}